import axios from "axios";
import { Base_URL } from "../url";

export const fetchAdvanceCashData = async () => {
  try {
    const response = await axios.get(`${Base_URL}/AdvanceReq/AdvanceCashGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Error fetching advance cash data!";
  }
};